import { ReactNode } from "react";
import { Box, Paper, Typography } from "@mui/material";
import { analyticsTheme, cardSx } from "../theme";

interface AnalyticsSectionCardProps {
  title: string;
  icon?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
  testId?: string;
}

export const AnalyticsSectionCard = ({
  title,
  icon,
  action,
  children,
  testId,
}: AnalyticsSectionCardProps) => (
  <Paper
    elevation={0}
    sx={{
      ...cardSx,
      height: "100%",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      "&:hover": {
        boxShadow: analyticsTheme.shadow.cardHover,
        borderColor: analyticsTheme.borderStrong,
      },
    }}
    data-testid={testId}
  >
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        px: 2.75,
        py: 2,
        borderBottom: `1px solid ${analyticsTheme.border}`,
      }}
    >
      {icon ? (
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: analyticsTheme.radius.sm,
            backgroundColor: analyticsTheme.brandSoft,
            color: analyticsTheme.brand,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            "& svg": { fontSize: 20 },
          }}
        >
          {icon}
        </Box>
      ) : null}
      <Typography
        sx={{
          fontSize: 16,
          fontWeight: 700,
          color: analyticsTheme.text.primary,
          letterSpacing: -0.2,
          flex: 1,
          minWidth: 0,
        }}
      >
        {title}
      </Typography>
      {action}
    </Box>

    <Box sx={{ p: 2.75, flex: 1, minHeight: 0 }}>{children}</Box>
  </Paper>
);
